import { Inject, Injectable, InjectionToken } from '@angular/core';
import { AccountGroup, AccountGroupService, LookupFilter, ProjectionFilter } from '@galaxy/account-group';
import { Observable, combineLatest } from 'rxjs';
import { skipWhile, switchMap } from 'rxjs/operators';

export const ACCOUNT_SELECTOR_SERVICE_TOKEN = new InjectionToken<AccountSelectorServiceConfig>(
  'general dependency data for the sales-ui account selector service',
);
export interface AccountSelectorServiceConfig {
  salespersonId$: Observable<string>;
  marketId$: Observable<string>;
  hasAccessToAllAccountsInMarket$: Observable<boolean>;
}

@Injectable()
export class AccountSelectorApiService {
  constructor(
    private readonly accountGroupService: AccountGroupService,
    @Inject(ACCOUNT_SELECTOR_SERVICE_TOKEN) private readonly config: AccountSelectorServiceConfig,
  ) {}

  get(accountGroupId: string, projectionFilter: ProjectionFilter): Observable<AccountGroup> {
    return this.accountGroupService.get(accountGroupId, projectionFilter);
  }

  search(projectionFilter: ProjectionFilter, searchTerm?: string, pageSize = 500): Observable<AccountGroup[]> {
    return combineLatest([
      this.config.hasAccessToAllAccountsInMarket$,
      this.config.salespersonId$,
      this.config.marketId$,
    ]).pipe(
      switchMap(([hasAllMarketAccess, salespersonId, marketId]) => {
        const filters = !hasAllMarketAccess ? new LookupFilter(salespersonId) : undefined;
        return this.accountGroupService.lookup(projectionFilter, [marketId], searchTerm, filters, pageSize).pipe(
          skipWhile((r) => r == null), // skip the first null values (and undefined)
        );
      }),
    );
  }
}
